import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from 'src/app/services/form.service';
import { FormGroup } from '@angular/forms';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { AppConstants } from 'src/app/app.constants';
import { ClipboardService } from 'ngx-clipboard';
import { UtilsService } from 'src/app/services/utils.service';
import Stepper from 'bs-stepper';
import { AfterViewInit } from '@angular/core';
import { ElementRef } from '@angular/core';
import { VotacionService } from 'src/app/services/votacion.service';
import { PreguntaService } from 'src/app/services/pregunta.service';
import { OpcionService } from 'src/app/services/opcion.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-obtenerresultadomodal',
  templateUrl: './obtenerresultadomodal.component.html',
  styleUrls: ['./obtenerresultadomodal.component.css']
})
export class ObtenerresultadomodalComponent implements OnInit, AfterViewInit {

  @Input() data;
  form: FormGroup;
  submitted: Boolean = false;
  stepperForm: Stepper;
  idVotacion: any;
  usuario: any;
  votacion: any;
  listaPreguntas: any;
  listaVotos: any;
  mostrarDescifrar: Boolean = true;
  mostrarPublicar: Boolean = false;

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private modal: ModalService,
    private alert: NotificacionesService, private utils: UtilsService, private clipboard: ClipboardService, private elementRef: ElementRef,
    private votacionService: VotacionService, private preguntaService: PreguntaService, private opcionService: OpcionService) {
    this.listaPreguntas = [];
    this.listaVotos = [];
  }

  ngOnInit(): void {
    this.form = this.formService.getObtenerResultadoModalForm(this.data);
    this.idVotacion = this.data.idVotacion;
    this.usuario = this.utils.obtenerDatosUsuario().usuario;
    this.loadDatosVotacion();
  }

  loadDatosVotacion() {
    this.modal.mostrarModalCargando();
    this.votacionService.obtenerPorId(this.idVotacion).subscribe((data: any) => {
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.data = data.votacion;
        this.votacion = data.votacion;
        this.form = this.formService.getObtenerResultadoModalForm(this.data);
        this.loadListaPreguntas(false);
        this.modal.cerrarModalCargando();
      } else {
        this.alert.error(data.mensaje, true);
        this.modal.cerrarModalCargando();
      }
    }, (error: any) => {
      this.alert.error('Error al cargar la información de la votación, intente de nuevo', true);
      console.error('Error', error);
      this.modal.cerrarModalCargando();
    });
  }

  loadListaPreguntas(showModalCargando?) {
    showModalCargando = this.utils.validarObjeto(showModalCargando) ? showModalCargando : true;
    if (showModalCargando)
      this.modal.mostrarModalCargando();
    this.preguntaService.obtenerTodasPorIdVotacion(this.votacion.idVotacion).subscribe((data: any) => {
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.listaPreguntas = data.boleta;
        this.listaPreguntas.map((pregunta) => { this.loadListaOpciones(pregunta, showModalCargando) });
        if (showModalCargando)
          this.modal.cerrarModalCargando();
      } else {
        this.listaPreguntas = [];
        if (showModalCargando)
          this.modal.cerrarModalCargando();
      }
    }, (error: any) => {
      this.alert.error('Error al cargar la lista de preguntas, intente de nuevo', true);
      this.listaPreguntas = [];
      console.error('Error', error);
      if (showModalCargando)
        this.modal.cerrarModalCargando();
    });
  }

  loadListaOpciones(pregunta, showModalCargando?) {
    showModalCargando = this.utils.validarObjeto(showModalCargando) ? showModalCargando : true;
    pregunta.listaOpciones = [];
    if (showModalCargando)
      this.modal.mostrarModalCargando();
    this.opcionService.obtenerTodosPorPregunta(pregunta.idPregunta).subscribe((data: any) => {
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        pregunta.listaOpciones = data.opciones;
        if (showModalCargando)
          this.modal.cerrarModalCargando();
      } else {
        pregunta.listaOpciones = [];
        if (showModalCargando)
          this.modal.cerrarModalCargando();
      }
    }, (error: any) => {
      this.alert.error('Error al cargar la lista de opciones para una pregunta, intente de nuevo', true);
      console.error('Error', error);
      pregunta.listaOpciones = [];
      if (showModalCargando)
        this.modal.cerrarModalCargando();
    });
  }

  loadListaVotos(privateKey, showModalCargando?) {
    showModalCargando = this.utils.validarObjeto(showModalCargando) ? showModalCargando : true;
    if (showModalCargando)
      this.modal.mostrarModalCargando();
    this.votacionService.obtenerVotosProducto(this.idVotacion).subscribe((data: any) => {
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.listaVotos = data.votosCifrados;
        this.listaPreguntas.map((pregunta) => {
          let votosPregunta = this.listaVotos.filter(voto => {
            return voto.idPregunta === pregunta.idPregunta;
          });
          // votosPregunta.map((votoCifrado) => {
          //   let votoDescifrado = this.utils.descifrarPaillier(votoCifrado.votosCifrados, privateKey).padStart(9, '0');
          //   console.log('votoDescifrado', votoDescifrado);
          //   let resultadoInvertido = this.utils.invertirTexto(votoDescifrado);
          //   let votoFactorizado = this.utils.descomponerValorMod10(resultadoInvertido, environment.ENVIRONMENT.NIVELES_MAXIMOS_CODIFICACION_VOTOS_BLOQUE);
          //   console.log('votoFactorizado', votoFactorizado);
          //   pregunta.listaOpciones.map((opcionPregunta) => {
          //     console.log('opcionPregunta', opcionPregunta);
          //     if (opcionPregunta.idBloque === votoCifrado.idBloque) {
          //       console.log('votoCifrado', votoCifrado);
          //       let sumaVotos = 0;
          //       votoFactorizado.map((voto) => {
          //         if (Number(opcionPregunta.codificacion) >= voto.base) {
          //           console.log('sumando', voto.resultadoFinal);
          //           sumaVotos += voto.resultadoFinal;
          //           voto.resultadoFinal = 0;
          //         }
          //       });
          //       opcionPregunta.resultado = sumaVotos;
          //     }
          //   });
          // });
          votosPregunta.map((votoCifrado) => {
            // console.log('votoCifrado', votoCifrado);
            let votoDescifrado = this.utils.descifrarPaillier(votoCifrado.votosCifrados, privateKey).padStart(9, '0');
            // console.log('votoDescifrado', votoDescifrado);
            pregunta.listaOpciones.map((opcionPregunta) => {
              if (opcionPregunta.idBloque === votoCifrado.idBloque) {
                // console.log('opcionPregunta', opcionPregunta);
                if (Number(opcionPregunta.codificacion) === 1) {
                  // console.log('votoDescifrado.substring(6,9)', votoDescifrado.substring(6,9));
                  opcionPregunta.resultado = Number(votoDescifrado.substring(6,9));
                } else if (Number(opcionPregunta.codificacion) === 1000) {
                  // console.log('votoDescifrado.substring(3,6)', votoDescifrado.substring(3,6));
                  opcionPregunta.resultado = Number(votoDescifrado.substring(3,6));
                } else if (Number(opcionPregunta.codificacion) === 1000000) {
                  // console.log('votoDescifrado.substring(0,3)', votoDescifrado.substring(0,3));
                  opcionPregunta.resultado = Number(votoDescifrado.substring(0,3));
                } else {
                  // console.log('No hay substring');
                  opcionPregunta.resultado = 0;  
                }
              }
            });
          });
          pregunta.listaOpciones.map((opcionPregunta) => {
            if (!this.utils.validarObjeto(opcionPregunta.resultado)) {
              opcionPregunta.resultado = 0;
            }
          });
        });
        if (showModalCargando)
          this.modal.cerrarModalCargando();
      } else {
        this.listaVotos = [];
        if (showModalCargando)
          this.modal.cerrarModalCargando();
      }
    }, (error: any) => {
      this.alert.error('Error al cargar los votos, intente de nuevo', true);
      console.error('Error', error);
      this.listaVotos = [];
      if (showModalCargando)
        this.modal.cerrarModalCargando();
    });
  }

  descifrar() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    let publicKey = this.utils.obtenerLlavePublicaPaillier(this.votacion.llavePublica);
    let privateKey = this.utils.obtenerLlavePrivadaPaillier(publicKey, this.form.value.llavePrivada);
    if (!this.utils.verificarLLavesPaillier(publicKey, privateKey)) {
      this.alert.warning('La llave privada que proporcionó no concuerda con la llave pública de la votación, introduzca la llave privada correcta', true);
    } else {
      this.loadListaVotos(privateKey, true);
      this.mostrarDescifrar = false;
      this.mostrarPublicar = true;
    }
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

  next() {
    this.stepperForm.next();
  }

  previous() {
    this.stepperForm.previous();
  }

  ngAfterViewInit() {
    this.stepperForm = new Stepper(document.querySelector('#stepperForm'), {
      linear: false,
      animation: true
    });
  }

  onSubmit() {
    return false;
  }

  publicar() {
    this.alert.question('Publicar Resultados', '¿Desea publicar los resultados y dar por finalizado el proceso de la votación?, la acción no se podrá deshacer después.').then((result) => {
      if (result.value) {
        let resultados = [];
        this.listaPreguntas.map((pregunta) => {
          pregunta.listaOpciones.map((opcion) => {
            resultados.push({ idOpcion: opcion.idOpcion, resultado: opcion.resultado });
          });
        });
        let requestGuardar = {
          idVotacion: this.votacion.idVotacion,
          resultados: resultados
        };
        this.modal.mostrarModalCargando();
        this.votacionService.guardarResultados(requestGuardar).subscribe((data: any) => {
          if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
            this.alert.success(data.mensaje, true);
            this.votacionService.publicarVotacion(this.votacion.idVotacion, this.usuario).subscribe((data: any) => {
              if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
                this.alert.success(data.mensaje, true);
                this.modal.cerrarModalCargando();
                this.mostrarPublicar = false;
              } else {
                this.alert.error(data.mensaje, true);
                this.modal.cerrarModalCargando();
              }
            }, (error: any) => {
              this.alert.error('Ocurrió un error al tratar de publicar la votación, intente de nuevo', true);
              console.error('Error', error);
              this.modal.cerrarModalCargando();
            });
          } else {
            this.alert.error(data.mensaje, true);
            this.modal.cerrarModalCargando();
          }
        }, (error: any) => {
          this.alert.error('Ocurrió un error al tratar de guardar los resultados de la votación, intente de nuevo', true);
          console.error('Error', error);
          this.modal.cerrarModalCargando();
        });
      }
    });
  }

}
